module.exports = __webpack_public_path__ + "static/media/signage-indoor-img31.9e2ce6ad.jpg";